import { createWrapper } from 'next-redux-wrapper';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { snackbarAction } from './settings/action';

const bindMiddleware = (middleware) => {
	if (process.env.NODE_ENV !== 'production') {
		const { composeWithDevTools } = require('redux-devtools-extension');
		return composeWithDevTools(applyMiddleware(...middleware));
	}
	return applyMiddleware(...middleware);
};

export const makeStore = () => {
	const sagaMiddleware = createSagaMiddleware();
	const store = createStore(
		rootReducer,
		{},
		bindMiddleware([
			sagaMiddleware,
			(_api) => (next) => (action) => {
				if (typeof window !== 'undefined' && action.type?.includes('SUCCESS')) {
					if (!action.payload.success && action.payload.message) {
						_api.dispatch(
							snackbarAction({
								message: action.payload.message,
								severity: 'error',
							}),
						);
					}
				}
				return next(action);
			},
		]),
	);
	store.sagaTask = sagaMiddleware.run(rootSaga);

	return store;
};

export const wrapper = createWrapper(makeStore);
